// Figma "Elevation/card"
export const ELEVATION =
  "0 1px 2px rgba(13, 13, 13, 0.04), 0 2px 8px rgba(13, 13, 13, 0.06)";

// Figma "Elevation/pop"
export const ELEVATION_POP = "0 12px 40px rgba(13, 13, 13, 0.12)";
